import React from 'react'
import { useTranslation } from 'react-i18next'

import { Tag } from 'primereact/tag'

import { FileMetaData } from '../../data/models'

type Props = {
  status: FileMetaData['status']
}

export const EInvoiceStatusTag: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation('eInvoiceOverview')

  const getSeverity = (status: FileMetaData['status']) => {
    switch (status) {
      case 'ReadyForCommit':
        return 'success'
      case 'Committed':
        return 'success'
      case 'UnverifiedInvoice':
        return 'warning'
      case 'FailedRulesEngineCheck':
        return 'danger'
      default:
        return 'info'
      // TODO: Other severities can be added as needed
      // "success" | "info" | "warning" | "danger" | null | undefined
    }
  }

  return (
    <Tag
      icon={getStatusIcon(status)}
      value={t(`table.columns.status.options.${status}`)}
      severity={getSeverity(status)}
      className="white-space-nowrap"
    />
  )
}

export type StatusTagProps = {
  id?: string
  status: FileMetaData['status']
  className?: string
}

export const StatusTag: React.FC<StatusTagProps> = ({
  id,
  status,
  className,
}) => {
  const { t } = useTranslation('eInvoiceOverview')

  if (!status) return null

  return (
    <Tag
      id={id}
      className={`text-xs font-bold px-2 white-space-nowrap ${getClassName(
        status,
      )} ${className ? className : ''}`}
      icon={getStatusIcon(status)}
      value={t(`table.columns.status.options.${status}`)}
    />
  )
}

const getClassName = (status: FileMetaData['status']) => {
  switch (status) {
    case 'ReadyForCommit':
    case 'Committed': {
      return 'bg-green-200 text-green-900'
    }
    case 'UnverifiedInvoice': {
      return 'bg-yellow-200 text-yellow-900'
    }
    case 'FailedRulesEngineCheck': {
      return 'bg-red-200 text-red-900'
    }
    default: {
      return 'bg-purple-200 text-purple-900'
    }
  }
}

const getStatusIcon = (status: FileMetaData['status']) => {
  switch (status) {
    case 'ReadyForCommit':
      return 'pi pi-send'
    case 'Committed':
      return 'pi pi-check'
    case 'UnverifiedInvoice':
      return 'pi pi-exclamation-triangle'
    case 'FailedRulesEngineCheck':
      return 'pi pi-times-circle'
    default: {
      return 'pi pi-question'
    }
  }
}
